import React from 'react';

const OurClients: React.FC = () => {
  const clients = [
    { id: 1, name: "Client 1", logo: "/client1.jpg", industry: "Forging" },
    { id: 2, name: "Client 2", logo: "/client2.jpg", industry: "Tube Manufacturing" },
    { id: 3, name: "Client 3", logo: "/client3.jpg", industry: "Manufacturing" },
    { id: 4, name: "Client 4", logo: "/client4.jpg", industry: "Fabrication" },
    { id: 5, name: "Client 5", logo: "/client5.jpg", industry: "Manufacturing" },
    { id: 6, name: "Client 6", logo: "/client6.jpg", industry: "Generator" },
    { id: 7, name: "Client 7", logo: "/client7.jpg", industry: "Motros & Generator" },
    { id: 8, name: "Client 8", logo: "/client8.jpg", industry: "Manufacturing" },
    { id: 9, name: "Client 9", logo: "/client9.jpg", industry: "Motros & Generator" },
    { id: 10, name: "Client 10", logo: "/client10.jpg", industry: "Fabrication" },
    { id: 11, name: "Client 11", logo: "/client11.jpg", industry: "Power Plant" },
    { id: 12, name: "Client 12", logo: "/client12.jpg", industry: "Power Generation" },
    { id: 13, name: "Client 13", logo: "/client13.jpg", industry: "Railways" },
    { id: 20, name: "Client 20", logo: "/client20.jpg", industry: "Steel Plant" },
    { id: 21, name: "Client 21", logo: "/client21.jpg", industry: "Engine Pump" },
    { id: 22, name: "Client 22", logo: "/client22.jpg", industry: "Motros & Generator" },
    { id: 23, name: "Client 23", logo: "/client23.jpg", industry: "Forging" },
    { id: 24, name: "Client 24", logo: "/client24.jpg", industry: "Automobile" },
    { id: 25, name: "Client 25", logo: "/client25.jpeg", industry: "Motros & Generator" },
    { id: 26, name: "Client 26", logo: "/client26.png", industry: "Automotive" },
    { id: 27, name: "Client 27", logo: "/client27.jpeg", industry: "Sugar Factory Karnataka" },
    { id: 28, name: "Client 28", logo: "/client28.jpeg", industry: "Sugar Mill Nepal" },
    { id: 29, name: "Client 29", logo: "/client29.png", industry: "Sugar Factory Kanchanpur" },
    { id: 30, name: "Client 30", logo: "/client30.jpeg", industry: "Sugar Factory Satara" },
  ];

  const industries = [
    "Oil & Gas", "Power Generation", "Manufacturing", "Aerospace", 
    "Automotive", "Construction", "Marine", "Petrochemicals", 
    "Steel & Metals", "Infrastructure"
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-avis-blue to-avis-dark text-white py-20">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl lg:text-6xl font-bold mb-6">Our Clients</h1>
            <p className="text-xl lg:text-2xl text-blue-100 max-w-3xl mx-auto">
              Trusted by leading companies across various industries
            </p>
          </div>
        </div>
      </section>

      {/* Client Statistics */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Client Success</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Our track record speaks for itself
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-avis-blue mb-2">500+</div>
              <div className="text-gray-600">Projects Completed</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-avis-blue mb-2">100+</div>
              <div className="text-gray-600">Happy Clients</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-avis-blue mb-2">8+</div>
              <div className="text-gray-600">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-avis-blue mb-2">10</div>
              <div className="text-gray-600">Industries Served</div>
            </div>
          </div>
        </div>
      </section>

      {/* Client Logos Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Valued Clients</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We are proud to serve these industry leaders
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-8">
            {clients.map((client) => (
              <div key={client.id} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center justify-center">
                <div className="w-20 h-20 mb-4 flex items-center justify-center">
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="max-w-full max-h-full object-contain"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = '/assets/logo.png';
                    }}
                  />
                </div>
                <h3 className="text-sm font-semibold text-gray-900 text-center mb-1">{client.name}</h3>
                <p className="text-xs text-gray-500 text-center">{client.industry}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Served */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Industries We Serve</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Comprehensive NDT solutions across diverse sectors
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {industries.map((industry, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-avis-blue rounded-full flex items-center justify-center mx-auto mb-3">
                  <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <p className="text-sm font-medium text-gray-700">{industry}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Clients Choose Us */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Why Clients Choose Us</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              The reasons why industry leaders trust us with their critical NDT needs
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-12 h-12 bg-avis-blue rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Reliability</h3>
              <p className="text-gray-600">Consistent, accurate results you can trust for critical decisions</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-12 h-12 bg-avis-blue rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Speed</h3>
              <p className="text-gray-600">Fast turnaround times without compromising on quality</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-12 h-12 bg-avis-blue rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Expertise</h3>
              <p className="text-gray-600">Certified professionals with deep industry knowledge</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-12 h-12 bg-avis-blue rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Technology</h3>
              <p className="text-gray-600">State-of-the-art equipment and advanced testing methods</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-12 h-12 bg-avis-blue rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Support</h3>
              <p className="text-gray-600">Comprehensive customer support throughout the project</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-12 h-12 bg-avis-blue rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Value</h3>
              <p className="text-gray-600">Competitive pricing with exceptional value for money</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-avis-blue text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Join Our Growing Client Base</h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Experience the AVIS difference for your NDT requirements
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/quotation"
              className="bg-white text-avis-blue px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-colors duration-200"
            >
              Request Quote
            </a>
            <a
              href="/services"
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-avis-blue transition-colors duration-200"
            >
              View Services
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurClients;
